var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.3155,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8432 15.3365C23.8432 10.6937 20.082 6.92566 15.4475 6.92566C10.8131 6.92566 7.05188 10.6937 7.05188 15.3365C7.05188 19.4074 9.93999 22.7969 13.7684 23.5792V17.8598H12.0893V15.3365H13.7684V13.2338C13.7684 11.6105 15.0865 10.29 16.7069 10.29H18.8058V12.8133H17.1267C16.6649 12.8133 16.2871 13.1917 16.2871 13.6543V15.3365H18.8058V17.8598H16.2871V23.7053C20.5269 23.2848 23.8432 19.7018 23.8432 15.3365Z",
    fill: "#052142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb_icon.9df93b3deac8986c89237c2809ef8b3e.svg";
export { ForwardRef as ReactComponent };